import styled from "styled-components";

export const ContentCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
    box-sizing: border-box;
`;

export const Title = styled.div`
    color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    box-sizing: border-box;
    display: flex; 
    flex-direction: row;
    align-items: flex-end;
    white-space: nowrap;
`;

export const TitleCn = styled.div`
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
`;

export const Content = styled.div`
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
    color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    box-sizing: border-box;
    display: flex; 
    flex-direction: row;
    align-items: flex-end;
    white-space: nowrap;
    margin-top: 82px;
`;

